import React from 'react'
import {Transaction} from './Transaction'
import './Transactions.css'

export const Transactions = (props) => {
  var rtransactions = [];
    var length = props.transactions.length;
    for(var i = length-1;i>=0;i--){
        rtransactions.push(props.transactions[i]);
    }
  return (
    <center>
    <h1 style={{color: "white", fontSize: "40px"}}>Your Transactions</h1><br></br><br></br><br></br>
    <div id='transaction-container'>
        {rtransactions.map((transaction)=>{
          return <Transaction transaction={transaction} key={transaction.tid} onDelete={props.onDelete}/>})}
       
    </div>
    </center>
  )
}
